export default "__VITE_ASSET__3J6fxpuM__"